import React from 'react';
import { PageTemplate } from '../../layout/PageTemplate/PageTemplate';
import { Card } from 'primereact/card';
import { Skeleton } from 'primereact/skeleton';

export const SettingsSkeleton = () => {
  return (
    <PageTemplate className='settings-page' title='Configuración'>
      <Card>
        <div className='settings-skeleton'>
          <div className='settings-section'>
            <Skeleton width='100%' height='40px' className='mb-4' />

            <div className='business-hours-skeleton'>
              {Array.from({ length: 7 }).map((_, index) => (
                <div key={index} className='business-day-skeleton'>
                  <div className='time-range'>
                    <div className='time-range-content'>
                      <Skeleton width='120px' height='40px' className='switch' />
                      <Skeleton width='100%' height='40px' className='time-input' />
                      <Skeleton width='100%' height='40px' className='time-input' />
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className='holiday-chips-skeleton'>
              <Skeleton width='100%' height='40px' className='mb-2' />
              <Skeleton width='100%' height='80px' />
            </div>
          </div>
        </div>
      </Card>

      <Card>
        <div className='settings-skeleton'>
          <div className='settings-section'>
            <Skeleton width='100%' height='40px' className='mb-2' />
            <Skeleton width='100%' height='40px' className='mb-2' />
          </div>
        </div>
      </Card>
    </PageTemplate>
  );
};
